module.exports = __webpack_public_path__ + "img/Feature.52c1d73e.png";